// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__jQL+G","icon__img":"Icon_icon__img__bt7z7"};